
import { useEffect, useState, Suspense } from "react";
import styles from "../../styles/pages/Home.module.scss"
import Link from "next/link";
import { useRouter, useSearchParams } from "next/navigation";
import moment from "moment";
import { addDays, differenceInDays } from 'date-fns';
import NewLoader from "../Loader/NewLoader";

function BookNowButtonWhiteInner({ setIsactive, style }) {
    const router = useRouter();
    const searchParams = useSearchParams();
    const [loader, setLoader] = useState(false);
    const [noOfNights, setNoOfNights] = useState(searchParams.get("npOfNights") || 1);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(() => {
        const tomorrow = addDays(new Date(), 1);
        return tomorrow;
    });

    const [checkin, setCheckin] = useState({
        day: searchParams.get("checkIn") || "",
        month: searchParams.get("checkIn") || "",
        year: searchParams.get("checkIn") || "",
    });

    const [checkout, setCheckout] = useState({
        day: searchParams.get("checkOut") || "",
        month: searchParams.get("checkOut") || "",
        year: searchParams.get("checkOut") || "",
    });

    useEffect(() => {
        const updateDateState = (date, setStateFunction) => {
            if (date !== null) {
                const day = date.getDate();
                const month = (date.getMonth() + 1).toString().padStart(2, "0");
                const year = date.getFullYear();
                setStateFunction({ day, month, year });
            }
        };

        updateDateState(startDate, setCheckin);
        updateDateState(endDate, setCheckout);

        const nights = moment(endDate).diff(moment(startDate), 'days');
        setNoOfNights(nights > 0 ? nights : 1);
    }, [startDate, endDate]);

    useEffect(() => {
        const nights = differenceInDays(endDate, startDate);
        setNoOfNights(nights);
    }, [startDate, endDate]);

    const formated_start_date = moment(startDate).format("YYYY-MM-DD");
    const formated_end_date = moment(endDate).format("YYYY-MM-DD");

    const handleSetInactive = () => {
        if (setIsactive) {
            setIsactive(false);
        }
    };

    const handleSubmit = async (event, hotelId) => {
        event.preventDefault();

        handleSetInactive()

        try {
            await router.push(
                `/searchresult/?hotelID=${hotelId}&checkinDay=${checkin.day}&checkinMonth=${checkin.month}&checkinYear=${checkin.year}&checkoutDay=${checkout.day}&checkoutMonth=${checkout.month}&checkoutYear=${checkout.year}&room=1&adult=2&children=0&checkIn=${formated_start_date}&checkOut=${formated_end_date}&noOfNights=${noOfNights}`,
                undefined,
                { shallow: false }
            );


        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoader(false);
        }
    };

    return (
        <>
            {/* {loader && <NewLoader />} */}
            <button className="common_btn_white_bg" style={style} onClick={(event) => handleSubmit(event, 17)}>Book Now</button>
        </>
    )
}

export default function BookNowButtonWhite(props) {
    return (
        <Suspense fallback={
            <button className="common_btn_white_bg" style={props?.style}>
                Book Now
            </button>
        }>
            <BookNowButtonWhiteInner {...props} />
        </Suspense>
    );
}